import { useState } from "react";

import { GisLayerTableType } from "types/generic";
import GisLayerJson from "components/adhoc/gislayerjson";
import GisLayerMasterLayersWidget from "components/adhoc/gislayermasterlayerswidget.component";
import ToastRequestHandler from "components/adhoc/toast-request-handler";
import { useRequestStatusManager } from "utils/hooks/use-request-status-manager.hook";

const GisLayerMaster = () => {
    const [rowSelected, setRowSelected] = useState<GisLayerTableType[]>([]);
    const [rowSelectedWithId, setRowSelectedWithId] = useState<
        GisLayerTableType[]
    >([]);
    const [rowData, setRowData] = useState<GisLayerTableType[]>([]);

    const {
        allContentIsReady,
        errorList,
        success,
        subscribeContent,
        unsubscribeContent,
        removeAllData,
        setError,
    } = useRequestStatusManager();

    const contentName = "gisLayerMaster";

    return (
        <div className="l-gis-layer-page-tab">
            <div className="l-gis-layer-page-tab__container">
                <div className="l-gis-layer-page-tab__table">
                    <GisLayerMasterLayersWidget
                        rowSelected={rowSelected}
                        setRowSelected={setRowSelected}
                        rowSelectedWithId={rowSelectedWithId}
                        setRowSelectedWithId={setRowSelectedWithId}
                        rowData={rowData}
                        setRowData={setRowData}
                        subscribeContent={subscribeContent}
                        unsubscribeContent={unsubscribeContent}
                        setError={setError}
                        contentName={contentName}
                    />
                </div>
                <div className="l-gis-layer-page-tab__json">
                    <GisLayerJson
                        rowSelected={rowSelected}
                        setRowSelected={setRowSelected}
                        rowSelectedWithId={rowSelectedWithId}
                        setRowSelectedWithId={setRowSelectedWithId}
                        rowData={rowData}
                        setRowData={setRowData}
                        subscribeContent={subscribeContent}
                        unsubscribeContent={unsubscribeContent}
                        setError={setError}
                        contentName={contentName}
                    />
                </div>
            </div>
            <ToastRequestHandler
                allContentIsReady={allContentIsReady}
                closeToast={removeAllData}
                errorList={errorList}
                success={success}
            />
        </div>
    );
};

export default GisLayerMaster;
